class Subnav {
    stateClasses = {
        active: 'subnav--open',
        open: 'subnav--visible'
    };

    isSubnavOpen = false;

    constructor($el, $header, openCallback, closeCallback, closeAll) {
        this.$el = $el;
        this.$nav = $('.nav');
        this.$subnav = $el.find('.nav__list--subnav');
        this.$header = $header;

        this.openCallback = openCallback;
        this.closeCallback = closeCallback;
        this.closeAll = closeAll;

        this.init();
    }

    init() {
        this.handleResponsiveEvents();
        $(window).on('resize', this.handleResponsiveEvents);
    }

    handleResponsiveEvents = () => {
        const isMobile = window.innerWidth <= 991;
        this.$el.off('mouseenter mouseleave click');

        if (isMobile) {
            this.$el.on('click', this.toggle);
        } else {
            this.$el.on('mouseenter', this.open);
            this.$el.on('mouseleave', this.close);
        }
    };

    open = () => {
        this.closeAll(false); 
        this.$el.addClass(this.stateClasses.open);
        this.$header.addClass(this.stateClasses.active);
        this.isSubnavOpen = true;

        this.openCallback();
    };

    close = (triggerCallback = true) => {
        this.$el.removeClass(this.stateClasses.open);
        this.$header.removeClass(this.stateClasses.active);
        this.isSubnavOpen = false;

        if (triggerCallback) this.closeCallback();
    };

    toggle = () => {
        this.isSubnavOpen ? this.close() : this.open();
    };
}

export default Subnav;
